import { render, staticRenderFns } from "./RegisterCandidate.vue?vue&type=template&id=d74ae988&"
import script from "./RegisterCandidate.vue?vue&type=script&lang=js&"
export * from "./RegisterCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports